import {useCurrentProfile} from '../react-sdk/queries';
import {CONFIG} from '../config';

export const useRole = () => {
  const currentProfile = useCurrentProfile();
  const isPersonal = currentProfile?.organization_id === CONFIG.PERSONAL_ORGID;
  const roles = currentProfile?.roles || [];
  const isAdmin = !isPersonal && (roles.includes('owner') || roles.includes('admin'));

  return {isPersonal, isAdmin};
};
